"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DatetimeInput_1 = require("../controls/DatetimeInput");
var core_1 = require("@veeam/core");
var FieldLayout_1 = require("../FieldLayout");
var helpers_1 = require("../helpers");
var DatetimeInput_2 = require("../controls/DatetimeInput");
var public_1 = require("../common/public");
var DEFAULT_ERROR_TEXTS = {
    gtEndDateError: 'The date greater end date',
    ltStartDateError: 'The date less than start date',
    parseError: 'The date is invalid',
    defaultError: 'The date is invalid'
};
var getDateValidationError = function (code, texts) {
    if (texts === void 0) { texts = {}; }
    var result = (function () {
        switch (code) {
            case DatetimeInput_2.DATETIME_INPUT_ERROR.gtEnd:
                return texts.gtEndDateError;
            case DatetimeInput_2.DATETIME_INPUT_ERROR.ltStart:
                return texts.ltStartDateError;
            case DatetimeInput_2.DATETIME_INPUT_ERROR.parse:
                return texts.parseError;
            default:
                return '';
        }
    })();
    return result || texts.defaultError;
};
exports.DateField = helpers_1.createUIElement('DateField', function (_a, ref) {
    var className = _a.className, field = _a.field, withTime = _a.withTime, startDatetime = _a.startDatetime, endDatetime = _a.endDatetime, texts = _a.texts, widthSize = _a.widthSize, size = _a.size, disabled = _a.disabled, controlRenderer = _a.controlRenderer, hasEnterKeyStopPropagation = _a.hasEnterKeyStopPropagation, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, asTag = _a.asTag, name = _a.name, suffix = _a.suffix, label = _a.label, helpText = _a.helpText, helpTextWrap = _a.helpTextWrap, errorProp = _a.error, children = _a.children, controlProp = _a.control, inlineLabel = _a.inlineLabel, errorView = _a.errorView, tooltipOffset = _a.tooltipOffset, rest = __rest(_a, ["className", "field", "withTime", "startDatetime", "endDatetime", "texts", "widthSize", "size", "disabled", "controlRenderer", "hasEnterKeyStopPropagation", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onKeyPress", "style", "asTag", "name", "suffix", "label", "helpText", "helpTextWrap", "error", "children", "control", "inlineLabel", "errorView", "tooltipOffset"]);
    var fieldSize = size || widthSize;
    return (react_1.default.createElement(core_1.Field, { field: field, render: function (_a) {
            var _b = _a.control, valueControl = _b.value, onChangeControl = _b.onChange, onBlurControl = _b.onBlur, nameControl = _b.name, error = _a.error, displayError = _a.meta.displayError;
            var errorTexts = __assign(__assign({}, DEFAULT_ERROR_TEXTS), texts);
            return (react_1.default.createElement(FieldLayout_1.FieldLayout, __assign({}, rest, { asTag: asTag, disabled: disabled, suffix: suffix, label: label, helpText: helpText, helpTextWrap: helpTextWrap, inlineLabel: inlineLabel, errorView: errorView, tooltipOffset: tooltipOffset, name: nameControl, "data-selector-id": rest['data-selector-id'], className: "vm-DateField " + className, size: fieldSize, error: displayError ? error : '', minWidth: DatetimeInput_1.MIN_WIDTH_DATETIME_INPUT, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
                react_1.default.createElement(DatetimeInput_1.DatetimeInput, { texts: texts, size: public_1.CONTROL_SIZE.full, disabled: disabled, error: displayError && !!error, controlRenderer: controlRenderer, onDateError: function (code) {
                        field.setError(getDateValidationError(code, errorTexts) || '');
                    }, withTime: withTime, startDatetime: startDatetime, endDatetime: endDatetime, value: valueControl, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, onChange: onChangeControl, onBlur: onBlurControl })));
        } }));
});
//# sourceMappingURL=DateField.js.map